import axiosInstance from './axiosCreator';
import type { LibraryHomeResponse } from '../types/Article';
import type { Video } from '../types/Video';

interface ReportArticleRequest {
  articleTitle: string;
  articleId: string;
  email: string;
  reason: string;
}

// Fetch article by slug or id
export const fetchArticle = async (slug: string) => {
  try {
    const response = await axiosInstance.get('/library/' + slug);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchArticleVideos = async (
  slug: string
): Promise<{ linkedVideos: Video[] } | undefined> => {
  try {
    const response = await axiosInstance.get(`/library/videos/${slug}`);
    return response.data as { linkedVideos: Video[] };
  } catch (error) {
    console.error(error);
  }
};

// Report article
export const reportArticle = async (reportInfo: ReportArticleRequest) => {
  try {
    const response = await axiosInstance.post('/library/report', reportInfo);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Get ArticlePreview for Article
export const fetchArticlePreview = async (id: string) => {
  try {
    const response = await axiosInstance.get('/article/' + id + '/preview');
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Get the current user's read state for an Article
export const fetchArticleReadState = async (
  id: string
): Promise<{ isRead: boolean } | undefined> => {
  try {
    const response = await axiosInstance.get(`/article/${id}/read-state`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// Fetch the personalized Library home page (v5). Throws on error so the page
// can degrade to its browse/search floor.
export const fetchLibraryHome = async (): Promise<LibraryHomeResponse> => {
  const response = await axiosInstance.get('/api/v5/library/home');
  return response.data as LibraryHomeResponse;
};

// Set the current user's read state for an Article
export const updateArticleReadState = async (
  id: string,
  isRead: boolean
): Promise<{ isRead: boolean } | undefined> => {
  try {
    const response = await axiosInstance.put(`/article/${id}/read-state`, {
      isRead,
    });

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
